import React, { useEffect, useState } from 'react';
import styles from './ApiActivityIndicator.module.css';

function ApiActivityIndicator() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleLoadingChange = (event) => {
      setIsLoading(Boolean(event?.detail?.isLoading));
    };

    window.addEventListener('api-loading-change', handleLoadingChange);
    return () => {
      window.removeEventListener('api-loading-change', handleLoadingChange);
    };
  }, []);

  return (
    <div className={`${styles.container} ${isLoading ? styles.visible : ''}`} aria-hidden={!isLoading}>
      <div className={styles.bar}></div>
    </div>
  );
}

export default ApiActivityIndicator;